export default __webpack_public_path__ + "media/images/tlr-3b4659cad438f7a8671ee1d8b2b57bd9.png";